export const SLAB = 'slab';
export const BIFOLD = 'bifold';
export const INTERNAL = 'internal';
export const EXTERNAL = 'external';
